import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";

export const useGetIngredientCategories = (
    queryKey: string | (string | number)[],
    options?: { enabled?: boolean; keepPreviousData?: boolean },
): UseQueryResult<types.IIngredientCategory[]> => {
    const auth = useAuth();

    return useQuery<types.IIngredientCategory[]>(
        queryKey,
        async () => {
            if (!auth.token) {
                throw new Error("Cannot fetch without authorization token.");
            }
            return await api.Ingredients.listCategories(auth.token);
        },
        options,
    );
};
